import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Ligue } from 'app/shared/models/List-Ligue/list-ligue';
import { UserService } from 'app/shared/services/user/user.service';

export interface DialogData {
  allLigues: Ligue[];
  codeLigueSave: number;
  fluxLigue: string;
  load: boolean;
}

@Component({
  selector: 'app-choice-ligue',
  templateUrl: './choice-ligue.component.html',
  styleUrls: ['./choice-ligue.component.scss']
})
export class ChoiceLigueComponent implements OnInit {

  ligueForm: FormGroup;
  allLigues: Ligue[];
  ligueDefault: Ligue;

  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<ChoiceLigueComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    this.allLigues = this.data.allLigues;
  }

  ngOnInit(): void {
    this.ligueDefault = this.allLigues.find(item => item.idLigue === this.data.codeLigueSave);
    this.data.fluxLigue = this.ligueDefault?.denomination;
  }


  closeDialog() {
    this.data.load = false;
  }


}
